import { RiskProfileStatsCard } from './RiskProfileStatsCard'
import { useMemo } from 'react'
import {
  SelectedElementProfileResponse,
  DamageState,
  SelectedElementProfile,
} from '../types/riskProfileSelected.types'
import { formatLongCurrency } from '@app/utils/numbers.utils'
import { clientConfigAtom } from '@app/state/clientsAtom'
import { useAtomValue } from 'jotai'

type SelectedElementStatsGridProps = {
  selectedProfileData: SelectedElementProfileResponse
}

const damage_states_order: Record<DamageState, number> = {
  unknown: 0,
  insignificant: 1,
  minor: 2,
  moderate: 3,
  major: 4,
  exposed: 5,
}

export const SelectedElementStatsGrid = ({
  selectedProfileData,
}: SelectedElementStatsGridProps) => {
  const clientConfig = useAtomValue(clientConfigAtom)

  const highestDamageCostScenario = useMemo(() => {
    if (!selectedProfileData || selectedProfileData.length === 0) {
      return null
    }
    return selectedProfileData.sort((a, b) => b.damage_cost - a.damage_cost)[0]
  }, [selectedProfileData])

  const highestDamageState = useMemo(() => {
    if (!selectedProfileData || selectedProfileData.length === 0) {
      return null
    }
    let highestState: DamageState = 'unknown'

    selectedProfileData.forEach((profile: SelectedElementProfile) => {
      profile.damage_states.forEach((each_state: DamageState) => {
        if (Number(damage_states_order[each_state]) > Number(damage_states_order[highestState])) {
          highestState = each_state
        }
      })
    })
    return highestState
  }, [selectedProfileData])

  const stats = [
    {
      label: 'DAMAGE COST',
      value: formatLongCurrency(highestDamageCostScenario?.damage_cost ?? 0, clientConfig?.locale),
      description: '-',
      tooltipDescription: 'Sum of maximum damage cost for this element in this workspace.',
    },
    {
      label: 'HIGHEST DAMAGE STATE',
      value: highestDamageState ?? '-',
      description: '-',
      tooltipDescription: 'TBC',
    },
    {
      label: 'TOP HAZARD',
      value: highestDamageCostScenario?.group_name.replaceAll('_', ' ') ?? '-',
      description: '-',
      tooltipDescription: 'Hazard with the highest summed damage cost for this element',
    },
  ]

  const isLoading = false

  return (
    <div className="w-full mt-5 max-w-full mx-auto">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 capitalize">
        {stats.map((stat) => (
          <RiskProfileStatsCard key={stat.label} {...stat} isLoading={isLoading} />
        ))}
      </div>
    </div>
  )
}
